import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["tab", "panel"]
  static values = {
    defaultTab: String
  }

  connect() {
    this.handleHashChange = this.handleHashChange.bind(this)
    this.activate(this.currentTab(), false)
    window.addEventListener("hashchange", this.handleHashChange)
  }

  disconnect() {
    window.removeEventListener("hashchange", this.handleHashChange)
  }

  switch(event) {
    const tab = event.currentTarget.dataset.tab
    if (!tab) return

    this.activate(tab, true)
  }

  handleHashChange() {
    this.activate(this.currentTab(), false)
  }

  currentTab() {
    const hash = window.location.hash.replace("#", "")
    const validTabs = this.tabTargets.map((el) => el.dataset.tab).filter(Boolean)
    if (validTabs.includes(hash)) return hash
    return this.defaultTabValue || validTabs[0]
  }

  activate(tab, updateHash) {
    this.tabTargets.forEach((el) => {
      const active = el.dataset.tab === tab
      el.classList.toggle("pw-tabs__tab--active", active)
      el.setAttribute("aria-selected", active ? "true" : "false")
      el.tabIndex = active ? 0 : -1
    })

    this.panelTargets.forEach((el) => {
      const active = el.dataset.tab === tab
      el.hidden = !active
      el.setAttribute("aria-hidden", active ? "false" : "true")
    })

    if (updateHash) {
      history.replaceState(null, "", `#${tab}`)
    }
  }
}
